var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collections-management"},[_c('BillingFlow',{staticStyle:{"align-self":"baseline"}}),_c('div',[_c('GeneralCollectionsSettings')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }